import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Slack lied to me",
  "description": "",
  "published": "2016-08-25T00:00:00.000Z",
  "redirect_from": ["/blog/slack-lied-to-me/swizec/6974"],
  "categories": "Back End, Ruby, Ruby (programming language), slack, Technical, user documentation",
  "hero": "./img/bqiWYiL.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I built my first Slack bot today.`}</p>
    <p>{`It has one job: to report a specific type of error, and to do so while impersonating the office dog. It might get more jobs in the future, but you have to start somewhere.`}</p>
    <p>{`Adding a Slack bot to your Rails app happens in three steps:`}</p>
    <ol>
      <li parentName="ol">{`Set up `}<a parentName="li" {...{
          "href": "https://slack.com/apps/new/A0F7YS25R-bots"
        }}>{`new custom integration`}</a>{`.`}</li>
      <li parentName="ol">{`Add `}<a parentName="li" {...{
          "href": "https://github.com/slack-ruby/slack-ruby-client"
        }}>{`slack-ruby-client`}</a>{` to your setup.`}</li>
      <li parentName="ol">{`Fiddle around until you reach the desired flexibility and feature set.`}</li>
    </ol>
    <p>{`When you’re done with the first step, Slack promises that your bot’s messages will have a friendly avatar and username.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "620px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/76b0de4c959310cb54b8a122e1f90a3a/2a195/bqiWYiL.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "14.349775784753364%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'57\\'%20viewBox=\\'0%200%20400%2057\\'%20preserveAspectRatio=\\'none\\'/%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/76b0de4c959310cb54b8a122e1f90a3a/ca0a1/bqiWYiL.webp 223w", "/static/76b0de4c959310cb54b8a122e1f90a3a/75680/bqiWYiL.webp 445w", "/static/76b0de4c959310cb54b8a122e1f90a3a/cf77e/bqiWYiL.webp 620w"],
              "sizes": "(max-width: 620px) 100vw, 620px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/76b0de4c959310cb54b8a122e1f90a3a/e92b6/bqiWYiL.png 223w", "/static/76b0de4c959310cb54b8a122e1f90a3a/e66bf/bqiWYiL.png 445w", "/static/76b0de4c959310cb54b8a122e1f90a3a/2a195/bqiWYiL.png 620w"],
              "sizes": "(max-width: 620px) 100vw, 620px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/76b0de4c959310cb54b8a122e1f90a3a/2a195/bqiWYiL.png",
              "alt": "bqiWYiL",
              "title": "bqiWYiL",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Instead, they don’t. Following the basic instructions, you get a grey bot image and default username.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "466px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/51f41364c5f0911ae678b010b02272e0/fc1a1/3yaqj8b.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "12.10762331838565%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'49\\'%20viewBox=\\'0%200%20400%2049\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%209v2l2%204c0%202%200%202-3%202l-4%201v6c0%206%200%206%202%206%204%200%201%202-3%202-5%201-6%202-4%204h26c3-2%202-3-4-4-4%200-7-2-3-2%202%200%202-1%202-6v-7h-3c-4%200-4%200-4-2l1-4%201-2h-6m28%205c0%205%200%205%203%205l3-2%201%201c2%202%205%201%207-2l1-2v2c0%202%200%203%202%203s2%200%201-2v-6c-2-1-4%200-4%202h-1c-2-1-5-1-6%201h-1l-2-2-2-1-1-2-1%205m32%2014l4%2010%202-3v-3l2%203%202%203%202-3v-3l1%203c1%203%204%204%206%201%202-2-1-5-4-5-1%201-2%200-2-1-1-2-1-2-2%201l-2%204v-4l-2-3-2%203-1%204-1-4c-1-2-3-5-3-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/51f41364c5f0911ae678b010b02272e0/ca0a1/3yaqj8b.webp 223w", "/static/51f41364c5f0911ae678b010b02272e0/75680/3yaqj8b.webp 445w", "/static/51f41364c5f0911ae678b010b02272e0/fbab0/3yaqj8b.webp 466w"],
              "sizes": "(max-width: 466px) 100vw, 466px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/51f41364c5f0911ae678b010b02272e0/e92b6/3yaqj8b.png 223w", "/static/51f41364c5f0911ae678b010b02272e0/e66bf/3yaqj8b.png 445w", "/static/51f41364c5f0911ae678b010b02272e0/fc1a1/3yaqj8b.png 466w"],
              "sizes": "(max-width: 466px) 100vw, 466px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/51f41364c5f0911ae678b010b02272e0/fc1a1/3yaqj8b.png",
              "alt": "3yaqj8b",
              "title": "3yaqj8b",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And so it begins. Outdated documentation. ?`}</p>
    <p>{`Basic API spec says that you should post messages with an `}<inlineCode parentName="p">{`as_user: true`}</inlineCode>{` flag, which makes the bot use its default settings from Step 1.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`#Setup stuff, goes in a global file somewhere. config/initializers/slack.rb for instance

<p>Slack.configure do |config|</p>

<p>config.token = ENV[‘SLACK_API_TOKEN’]</p>

<p>end</p>

#Instantiate client

<p>client = Slack::Web::Client.new</p>

#Send message to #general channel

<p>client.chat_postMessage(channel: ‘#general’, text: ‘Hello World’, as_user: true)</p>
`}</code></pre>
    <p>{`That code throws an error `}<inlineCode parentName="p">{`-> user not in channel`}</inlineCode>{`. So you dig through the documentation and find `}<inlineCode parentName="p">{`channels_join`}</inlineCode>{`. But that throws an error, too `}<inlineCode parentName="p">{`-> user is a bot`}</inlineCode>{`.`}</p>
    <p>{`Bots can’t join channels.`}</p>
    <p>{`If you remove `}<inlineCode parentName="p">{`as_user: true`}</inlineCode>{`, then you can post, but you post without an avatar and without a username. Ugh.`}</p>
    <p>{`The easiest workaround is to explicitly add a username and an avatar to your post call. It makes half of Step 1 redundant, but your bot messages look great, and your team gets excited.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "554px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0761630798bd32aebe1f4cbe731277f5/04abd/xWO1Rwg.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "26.905829596412556%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'107\\'%20viewBox=\\'0%200%20400%20107\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2075c-2%201-1%2023%200%2024l6%201c5%200%205%200%205-3%200-2%200-2%202-2s2%200%200%203c0%202%200%202%206%202h6V74H26l-13%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0761630798bd32aebe1f4cbe731277f5/ca0a1/xWO1Rwg.webp 223w", "/static/0761630798bd32aebe1f4cbe731277f5/75680/xWO1Rwg.webp 445w", "/static/0761630798bd32aebe1f4cbe731277f5/5e3e0/xWO1Rwg.webp 554w"],
              "sizes": "(max-width: 554px) 100vw, 554px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0761630798bd32aebe1f4cbe731277f5/e92b6/xWO1Rwg.png 223w", "/static/0761630798bd32aebe1f4cbe731277f5/e66bf/xWO1Rwg.png 445w", "/static/0761630798bd32aebe1f4cbe731277f5/04abd/xWO1Rwg.png 554w"],
              "sizes": "(max-width: 554px) 100vw, 554px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/0761630798bd32aebe1f4cbe731277f5/04abd/xWO1Rwg.png",
              "alt": "xWO1Rwg",
              "title": "xWO1Rwg",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`If only they knew @quentin will only ever post errors.`}</p>
    <p>{`Another way to get around the bots-cant-join-channels problem is to mention @quentin, then invite him to the channel. I’m sure that will never get difficult or annoying to manage. No chance at all.`}</p>
    <p>{`It’s probably best to stick to the workaround.`}</p>
    <p>{`Giving a voice to the office dog is fun and all, but the useful stuff begins when you look into attachments. Slack lets you add rich attachments to your messages. Anything from semantically color-coded styling to buttons for common actions.`}</p>
    <p>{`I’m keeping it simple for now: report error, add contextual logs. In theory, this will help us quickly decide which errors are worth looking into and which aren’t.`}</p>
    <p>{`Adding attachments looks like this for me:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`client.chat_postMessage(
    channel: '#bot-test',
    text: "this is *bold*",
    attachments: [{
    color: 'warning',
    fallback: title,
    title: title,
    title_link: session_url,
    text: "*executed_at*\\t*created_at*\\t*user*\\t*event*",
    ts: Time.now.to_f
}])
`}</code></pre>
    <p>{`It creates a message like this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "487px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f2a345d7cb23653bdb4820fd81817502/7b439/3FZOz5A.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "27.3542600896861%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'110\\'%20viewBox=\\'0%200%20400%20110\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M37%2072c0%2021%201%2027%202%2028l1-28c0-24%200-28-2-28l-1%2028\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f2a345d7cb23653bdb4820fd81817502/ca0a1/3FZOz5A.webp 223w", "/static/f2a345d7cb23653bdb4820fd81817502/75680/3FZOz5A.webp 445w", "/static/f2a345d7cb23653bdb4820fd81817502/9d50c/3FZOz5A.webp 487w"],
              "sizes": "(max-width: 487px) 100vw, 487px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/f2a345d7cb23653bdb4820fd81817502/e92b6/3FZOz5A.png 223w", "/static/f2a345d7cb23653bdb4820fd81817502/e66bf/3FZOz5A.png 445w", "/static/f2a345d7cb23653bdb4820fd81817502/7b439/3FZOz5A.png 487w"],
              "sizes": "(max-width: 487px) 100vw, 487px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/f2a345d7cb23653bdb4820fd81817502/7b439/3FZOz5A.png",
              "alt": "3FZOz5A",
              "title": "3FZOz5A",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`See those asterisks? Those are not supposed to be there. `}<a parentName="p" {...{
        "href": "https://api.slack.com/docs/message-formatting"
      }}>{`Slack’s message formatting rules`}</a>{` say that strings wrapped in asterisks should render bold anywhere they appear. Messages, attachments, everywhere, `}<strong parentName="p">{`bold`}</strong>{`.`}</p>
    <p>{`Instead, it works for the message itself but not for the attachment. Possible reasons range from a Slack bug, to a library bug, to something strange happening in how I call the library. I haven’t figured it out, and I’m probably going to decide it’s not worth my time.`}</p>
    <p>{`But the office dog speaks now. ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      